
import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component({})
export default class Spinner extends Vue {
  @Prop({ required: false, default: null }) readonly message!: string;
}
